import React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

const ButtonComponent = ({ size, color, name, onClick }) => {
    const theme = useTheme();

    // Use the colors directly from the theme palette
    const getColor = () => {
        switch (color) {
            case "primary":
                return theme.palette.primary.main;
            case "secondary":
                return theme.palette.secondary.main;
            default:
                return theme.palette.primary.main;
        }
    };

    // Dynamically set the button width based on size
    const getWidth = () => {
        return size === "large" ? "300px" : "200px";
    };

    return (
        <Button
            variant="contained"
            style={{
                backgroundColor: getColor(),
                color: "#000", // Always set text color to black
                padding: "10px 20px",
                border: "none",
                borderRadius: "0px",
                cursor: "pointer",
                transition: "background-color 0.3s, transform 0.3s",
                display: "flex",
                gap: "10px",
                flexDirection: "row",
                width: getWidth(), // Adjust width dynamically
                alignItems: "center",
                justifyContent: "center",
            }}
            size={size || "medium"}
            onClick={onClick} // Call the passed function when clicked
        >
            {name}
        </Button>
    );
};

export default ButtonComponent;
